import { Grid } from "@mui/material"
import Box from "@mui/material/Box"
import Collapse from "@mui/material/Collapse"
import Paper from "@mui/material/Paper"
import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"

import TimeDetailIcon from "../components/TimeDetailIcon"
import { characterMap } from "../models/character"
import { Game } from "../models/game"
import { gliderMap } from "../models/glider"
import { tireMap } from "../models/tire"
import { vehicleMap } from "../models/vehicle"
import DownloadGhost from "./DownloadGhost"

interface TimeDetailProps {
  open: boolean
  game: Game
  trackId: number
  playerId: string
  character: number
  variant: number
  miiWeightClass: number
  laps: string[]
  vehicle: number
  tire: number
  glider: number
  coins: string
  shrooms: string
}

export default function TimeDetail(props: TimeDetailProps) {
  const {
    open,
    trackId,
    playerId,
    game,
    character,
    variant,
    miiWeightClass,
    laps,
    vehicle,
    tire,
    glider,
    coins,
    shrooms,
  } = props

  const characterObj = characterMap[game].find((x) => {
    if (x.id === 29 || x.id === 52)
      return x.id === character && x.miiWeightClass === miiWeightClass
    if (variant) return x.id === character && x.variant === variant
    return x.id === character
  })
  const vehicleObj = vehicleMap[game].find((x) => x.id === vehicle)
  const tireObj = tireMap[game].find((x) => x.id === tire)
  const gliderObj = gliderMap[game].find((x) => x.id === glider)

  return (
    <TableRow sx={(theme) => ({ backgroundColor: theme.palette.action.hover })}>
      <TableCell sx={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
        <Collapse
          in={open}
          timeout="auto"
          unmountOnExit
          sx={{ padding: "8px 0px" }}
        >
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={2} textAlign="center">
              <TimeDetailIcon
                folder="characters"
                name={characterObj?.name ?? ""}
                icon={characterObj?.icon ?? ""}
                height="64"
              ></TimeDetailIcon>
            </Grid>
            <Grid item xs={3}>
              <Paper sx={{ padding: "6px 12px" }}>
                {laps.map((lap, i) => (
                  <Box>
                    <TimeDetailIcon
                      folder="laps"
                      name={"Lap " + (i + 1)}
                      icon={"lap" + (i + 1)}
                      height="20"
                    ></TimeDetailIcon>
                    <span
                      style={{
                        position: "relative",
                        marginLeft: "6px",
                        top: "-5px",
                      }}
                    >
                      {lap}
                    </span>
                    <br></br>
                  </Box>
                ))}
              </Paper>
            </Grid>
            <Grid item xs={3}>
              <Paper sx={{ padding: "6px 12px" }}>
                <Box>
                  <TimeDetailIcon
                    folder="vehicles"
                    name={vehicleObj?.name ?? ""}
                    icon={vehicleObj?.icon ?? ""}
                    height="20"
                  ></TimeDetailIcon>
                  <span
                    style={{
                      position: "relative",
                      marginLeft: "6px",
                      top: "-5px",
                    }}
                  >
                    {vehicleObj?.name}
                  </span>
                  <br></br>
                </Box>
                <Box>
                  <TimeDetailIcon
                    folder="tires"
                    name={tireObj?.name ?? ""}
                    icon={tireObj?.icon ?? ""}
                    height="20"
                  ></TimeDetailIcon>
                  <span
                    style={{
                      position: "relative",
                      marginLeft: "6px",
                      top: "-5px",
                    }}
                  >
                    {tireObj?.name}
                  </span>
                  <br></br>
                </Box>
                <Box>
                  <TimeDetailIcon
                    folder="gliders"
                    name={gliderObj?.name ?? ""}
                    icon={gliderObj?.icon ?? ""}
                    height="20"
                  ></TimeDetailIcon>
                  <span
                    style={{
                      position: "relative",
                      marginLeft: "6px",
                      top: "-5px",
                    }}
                  >
                    {gliderObj?.name}
                  </span>
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={3}>
              <Paper sx={{ padding: "6px 12px" }}>
                <Box>
                  <TimeDetailIcon
                    folder="items"
                    name="Coins"
                    icon="coin"
                    height="20"
                  ></TimeDetailIcon>
                  <span
                    style={{
                      position: "relative",
                      marginLeft: "12px",
                      top: "-5px",
                    }}
                  >
                    {coins}
                  </span>
                  <br></br>
                </Box>
                <Box>
                  <TimeDetailIcon
                    folder="items"
                    name="Shrooms"
                    icon="mushroom"
                    height="20"
                  ></TimeDetailIcon>
                  <span
                    style={{
                      position: "relative",
                      marginLeft: "9px",
                      top: "-5px",
                    }}
                  >
                    {shrooms}
                  </span>
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={1} textAlign="right">
              <DownloadGhost game={game} trackId={trackId} playerId={playerId}></DownloadGhost>
            </Grid>
          </Grid>
        </Collapse>
      </TableCell>
    </TableRow>
  )
}
